import * as React from "react"
import styled from "styled-components"
import { ChildrenProps } from "../../@types/@core"
import { scale, colors } from "../../styles"
import {
	space,
	SpaceProps,
	size,
	layoutSize,
	SizeProps,
	LayoutSizeProps,
} from "../../styles/styled-system"

export interface PersonCardProps
	extends SpaceProps,
		SizeProps,
		LayoutSizeProps,
		ChildrenProps {}

const PersonCardStyled = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	border: 1px solid ${colors.blue33};
	border-radius: ${scale.px(3)};
	${space}
	${size}
	${layoutSize}

	a {
		:hover {
			color: ${({ theme }) => theme.colors.hoverBlue};
		}
	}
`

const PersonCard: React.FC<PersonCardProps> = (props) => (
	<PersonCardStyled {...props}>{props.children}</PersonCardStyled>
)

export { PersonCard }
